
import { DocumentContentEditor } from "./DocumentContentEditor";

interface BoardStrategyViewProps {
  content: any;
  documentId: string;
  onUpdate: () => void;
}

export function BoardStrategyView({ content, documentId, onUpdate }: BoardStrategyViewProps) {
  return (
    <div className="space-y-8">
      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Executive Summary</h2>
        <DocumentContentEditor
          section="Executive Summary"
          content={content.executiveSummary}
          documentId={documentId}
          field="executiveSummary"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Strategic Initiatives</h2>
        <DocumentContentEditor
          section="Strategic Initiatives"
          content={content.strategicInitiatives}
          documentId={documentId}
          field="strategicInitiatives"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Financial Performance</h2>
        <DocumentContentEditor
          section="Financial Performance"
          content={content.financialPerformance}
          documentId={documentId}
          field="financialPerformance"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Risk Management</h2>
        <DocumentContentEditor
          section="Risk Management"
          content={content.riskManagement}
          documentId={documentId}
          field="riskManagement"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Governance & Compliance</h2>
        <DocumentContentEditor
          section="Governance & Compliance"
          content={content.governanceCompliance}
          documentId={documentId}
          field="governanceCompliance"
          onUpdate={onUpdate}
        />
      </section>

      <section className="bg-white rounded-lg p-6 shadow-sm">
        <h2 className="text-2xl font-semibold mb-4">Board Recommendations</h2>
        <DocumentContentEditor
          section="Board Recommendations"
          content={content.boardRecommendations}
          documentId={documentId}
          field="boardRecommendations"
          onUpdate={onUpdate}
        />
      </section>
    </div>
  );
}
